import auth from "@/middleware/auth";
import hasRoles from "@/middleware/hasRoles";

export default {
  path: "",
  name: "AdminDashboard",
  meta: {
    middlewares: [auth, hasRoles],
    roles: ["admin"],
  },
  children: [
    {
      path: "doctors",
      name: "AdminDoctors",
      component: () =>
        import(
          /* webpackChunkName: "admin-doctors" */ "@/views/Admin/Doctors.vue"
        ),
    },
    {
      path: "raports",
      name: "AdminRaports",
      component: () =>
        import(
          /* webpackChunkName: "admin-doctors" */ "@/views/Admin/Raports.vue"
        ),
    },
    {
      path: "raports-links",
      name: "AdminRaportsLinks",
      component: () =>
        import(
          /* webpackChunkName: "admin-doctors" */ "@/views/Admin/DailyRaportLinks.vue"
        ),
    },
    {
      path: "referrals",
      name: "AdminReferrals",
      component: () =>
        import(
          /* webpackChunkName: "admin-orders" */ "@/views/Admin/Referrals.vue"
        ),
    },
    {
      path: "stats",
      name: "AdminStats",
      component: () =>
        import(
          /* webpackChunkName: "admin-orders" */ "@/views/Admin/Stats.vue"
        ),
    },
    {
      path: "invoices",
      name: "AdminInvoices",
      component: () =>
        import(
          /* webpackChunkName: "admin-invoices" */ "@/views/Admin/Invoices.vue"
        ),
    },
    {
      path: "promotions",
      name: "AdminPromotions",
      component: () =>
        import(
          /* webpackChunkName: "admin-invoices" */ "@/views/Admin/Promotions.vue"
        ),
    },
    {
      path: "createdinvoices",
      name: "AdminCreatedInvoices",
      component: () =>
        import(
          /* webpackChunkName: "admin-invoices" */ "@/views/Admin/CreatedInvoices.vue"
        ),
    },
    {
      path: "features",
      name: "Features",
      component: () =>
        import(
          /* webpackChunkName: "admin-features" */ "@/views/Admin/Features.vue"
        ),
    },
    {
      path: "data-management",
      name: "DataManagement",
      component: () =>
        import(
          /* webpackChunkName: "admin-features" */ "@/views/Admin/DataManagement.vue"
        ),
    },
    {
      path: "raports",
      name: "Raports",
      component: () =>
        import(
          /* webpackChunkName: "admin-features" */ "@/views/Admin/Raports.vue"
        ),
    },
    {
      path: "referral-errors",
      name: "AdminReferralErrors",
      component: () =>
        import(
          /* webpackChunkName: "admin-features" */ "@/views/Admin/ReferralError.vue"
        ),
    },
    {
      path: "detail-referral-errors/:id",
      name: "AdminDetailReferralErrors",
      props: (route) => ({ id: route.params.id * 1 }),
      component: () =>
        import(
          /* webpackChunkName: "admin-features" */ "@/views/Admin/DetailReferralError.vue"
        ),
    },
    {
      path: "doctor-create",
      name: "AdminCreateDoctor",
      component: () =>
        import(
          /* webpackChunkName: "admin-doctor-create" */ "@/views/Admin/DoctorCreate.vue"
        ),
    },
    {
      path: "doctor-edit/:id",
      name: "AdminUpdateDoctor",
      props: (route) => ({ id: route.params.id * 1 }),
      component: () =>
        import(
          /* webpackChunkName: "patient-referral-examination" */ "@/views/Admin/DoctorCreate.vue"
        ),
    },
    {
      path: "doctor/:id",
      name: "AdminDoctorCard",
      props: (route) => ({ id: route.params.id * 1 }),
      component: () =>
        import(
          /* webpackChunkName: "patient-referral-examination" */ "@/views/Admin/DoctorCard.vue"
        ),
    },
    {
      path: "doctors",
      name: "AdminDoctorsMessage",
      component: () =>
        import(
          /* webpackChunkName: "admin-doctors-message" */ "@/views/Admin/MessageForm.vue"
        ),
    },
    {
      path: "patient-list",
      name: "AdminPatientList",
      component: () =>
        import(
          /* webpackChunkName: "doctor-patient-list" */ "@/views/Admin/PatientList.vue"
        ),
    },
  ],
};
